<template>
    <b-modal
        @show="generateReport"
        @hide="resetModal"
        class="pt-8"
        v-model="showModal"
        title="Master Items Details Report"
        ref="modal"
    >
        <b-spinner
            v-show="loading"
            variant="primary"
            label="Spinning"
        ></b-spinner>
        <div v-if="!!reportUrl">
            <a :href="reportUrl" target="_blank" download
                >Click To Download Report</a
            >
        </div>

        <template #modal-footer="{ cancel }">
            <!-- Emulate built in modal footer ok and cancel button actions -->
            <b-button size="sm" variant="danger" @click="cancel()">
                Cancel
            </b-button>
        </template>
    </b-modal>
</template>

<script>
import popupMixins from '@/mixins/popupMixins'

export default {
    mixins: [popupMixins],
    data() {
        return {
            reportUrl: null,
            showModal: false,
            loading: false,
            reportType: 'master_item_details',
            queryModel: {},
        }
    },
    props: ['queryData'],
    computed: {
        baseReportUrl() {
            return this.$store.getters['js_report/reportUrl']
        },
    },

    watch: {
        baseReportUrl: function (url) {
            console.log('report URL', url)
            this.reportUrl =
                url + '&query=' + btoa(JSON.stringify(this.queryModel))
        },
        reportType: function () {
            this.reportUrl = null
        },
        queryData: function (val) {
            console.log('this.queryData', val)
            this.queryModel = val
        },
        reportUrl: function () {
            this.loading = false
        },
    },
    mounted() {},
    methods: {
        resetModal() {
            this.reportUrl = null
        },
        show() {
            this.showModal = true
            this.loading = true
        },
        close() {
            this.showModal = false
        },
        async generateReport() {
            try {
                const { reportType: rpt_type } = this
                this.queryModel = {
                    ...{ name: this.queryData },
                    ...{ rpt_type },
                }

                console.log('queryModel', this.queryModel, this.queryData)
                this.$store.dispatch('js_report/fetchCredentials', rpt_type)
            } catch (err) {
                this.doToast(
                    'Error!',
                    'Error Detected. Please consult your System Administrator',
                    'danger'
                )
            }
        },

        doNothing() {},
    },
}
</script>

<style scoped></style>
